// extracted by mini-css-extract-plugin
module.exports = {"container":"Overlay_container__20BWV","icon":"Overlay_icon__mborf"};